import { useEffect, useState } from 'react'

// The rail lives in the authenticated shell, so it is only in the DOM after the first paint.
export function useRightRailTarget(): HTMLElement | null {
  const [target, setTarget] = useState<HTMLElement | null>(null)
  useEffect(() => {
    setTarget(document.getElementById('right-rail'))
  }, [])
  return target
}
